import { useState, useEffect } from 'react'
import { Response } from 'request-dot-js'

import { FormErrorMessage } from 'common/FormErrorMessage/FormErrorMessage'
import SharedStyles from '../../Shared.module.scss'
import { navigateToExternalUrl } from 'utils/location'
import { REACT_APP_FRONTEND_URL } from 'env'

const FRONTEND_URI = new URL(REACT_APP_FRONTEND_URL)

const TIME_BEFORE_REDIRECT = 5000

export const CustomDomainError = ({
  error,
  customDomain,
}: {
  error: Response | null
  customDomain: string | undefined
}) => {
  const [notFound, setNotFound] = useState(false)
  const [noMember, setNoMember] = useState(false)

  const redirectSoon = () => {
    setTimeout(() => navigateToExternalUrl(FRONTEND_URI.toString()), TIME_BEFORE_REDIRECT)
  }

  useEffect(() => {
    if (!error) {
      setNotFound(false)
      setNoMember(false)
      return
    }

    if (error.data.errors?.workspace_domain && error.data.errors.workspace_domain.includes('not found')) {
      setNotFound(true)
      redirectSoon()
      return
    }

    if (error.data.errors?.workspace_domain && error.data.errors.workspace_domain.includes('no member')) {
      setNoMember(true)
      redirectSoon()
      return
    }
  }, [error])

  return (
    <>
      {error && customDomain && (
        <FormErrorMessage>
          <div className={SharedStyles.unauthorizedUser}>
            {notFound && (
              <>
                <b>{customDomain}</b> is not a registered workspace domain. You are being redirected to{' '}
                <a href={FRONTEND_URI.toString()}>almanac.io</a> now.
              </>
            )}
            {noMember && (
              <>
                <b>You are not a member of the workspace at {customDomain}</b>. You are being redirected to{' '}
                <a href={FRONTEND_URI.toString()}>almanac.io</a> now.
              </>
            )}
          </div>
        </FormErrorMessage>
      )}
    </>
  )
}
